module.exports = __webpack_public_path__ + "static/media/HARD-BNB.6e24d7a2.svg";